import React from 'react';
import PropTypes from 'prop-types';

import {Box, Typography, screenSizeSmaller} from 'views/components';
import ContactBox from './ContactBoxView';
import {Translate} from 'views/module';

const FamilyContactsBox = (props) => {
  const {data} = props;

  const isMobile = screenSizeSmaller('md');

  return (
    <Box style={{background: 'white', borderRadius: '1rem', boxShadow: '0 1px 6px rgba(0,0,0,0.1)', padding: '1rem', position: 'relative'}}>
      <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '0.5rem'}}>
        <Typography variant="h6">
          <Translate expression="profile.FamilyContactsBox.Title" />
        </Typography>
      </Box>

      {/* Render contacts in rows of one if isMobile, otherwise in rows of two */}
      {
        data.contacts && (
          Array.from({length: Math.ceil((data.contacts.length) / (isMobile ? 1 : 2))}).map((_, rowIdx) => (
            <Box key={rowIdx} sx={{display: 'flex', gap: '1rem', mb: '1rem'}}>
              {(isMobile ? [0] : [0, 1]).map((colIdx) => {
                const contactIdx = rowIdx * (isMobile ? 1 : 2) + colIdx;
                if (contactIdx < data.contacts.length) {
                  const contact = data.contacts[contactIdx];
                  return (
                    <Box key={contactIdx} sx={{flex: 1, minWidth: 0}}>
                      <ContactBox data={contact} />
                    </Box>
                  );
                } else {
                  // Fill empty space if odd number of contacts
                  return <Box key={contactIdx} sx={{flex: 1, minWidth: 0}} />;
                }
              })}
            </Box>
          ))
        )
      }
      {
        !data.contacts && (
          <Typography style={{color: '#71717A', fontStyle: 'italic', fontSize: '0.875rem', marginTop: '0.5rem'}}>
            <Translate expression="profile.FamilyContactsBox.ContactsPlaceholder" />
          </Typography>
        )
      }
    </Box>
  );
};

FamilyContactsBox.propTypes = {
  data: PropTypes.shape({
    contacts: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
};

export default FamilyContactsBox;
